import React from 'react';

import Box from '@mui/material/Box';

import FormSelectField from './FormSelectField';
import { sharedClasses } from './sharedClasses';
import { BODY_TEXT } from '../../../ThemeContext/constants';

import type { IFieldChoice } from '../Utilities/QuestionFieldGenerator';

const populateRanks = (choices: IFieldChoice[]) => {
  const ranks: Record<string, string> = {};
  choices.forEach((choice, index) => {
    ranks[choice.id] = (index + 1).toString();
  });
  return ranks;
};

const FormRankField = ({
  choices,
  onChange,
  groupLabel,
  innerRef,
  error,
  required,
  defaultValue,
  disabled = false,
  renderChoiceName
}: {
  choices: IFieldChoice[];
  onChange?: (value: Record<string | number, string>) => void;
  groupLabel?: string;
  innerRef?: React.Ref<HTMLDivElement>;
  error?: string;
  required?: boolean;
  defaultValue?: Record<string, number>;
  disabled?: boolean;
  renderChoiceName?: (choice: IFieldChoice) => React.ReactNode;
}) => {
  const [ranks, setRanks] = React.useState(defaultValue ?? populateRanks(choices));
  const options = choices.map((_, index: number) => (index + 1).toString());

  const handleChange = (value: string | number, name: string | number) => {
    const newRanks = { ...ranks, [name]: value };
    setRanks(newRanks);
    onChange?.(newRanks);
  };

  return (
    <Box ref={innerRef}>
      {groupLabel ? (
        <Box sx={sharedClasses.groupLabel}>
          {groupLabel}
          {required ? <span>*</span> : null}
        </Box>
      ) : null}
      {choices.map((choice) => (
        <Box key={choice.id} sx={sharedClasses.rankFieldOption}>
          <FormSelectField
            defaultValue={ranks[choice.id]}
            isDisabled={disabled}
            options={options}
            styles={sharedClasses.rankFieldSelect}
            onChange={(value) => {
              handleChange(value, choice.id);
            }}
          />
          <Box sx={{ width: '80%', color: BODY_TEXT }}>
            {renderChoiceName ? renderChoiceName(choice) : choice.name}
          </Box>
        </Box>
      ))}
      {error ? (
        <Box sx={{ ...sharedClasses.errorBoxCheckbox, marginLeft: '14px' }}>{error}</Box>
      ) : null}
    </Box>
  );
};

export default FormRankField;
